import React from 'react'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Portlet, Col, Row, Form, Button } from '_zari/core'

import * as TempInventarioCrud from 'services/tempInventario.service'
import * as UsuarioCrud from 'services/usuario.service'

import { DateHandler } from 'utils'

import ConfirmarProcesamientoModal from './modals/confirmarProcesamiento'

import { DownloadAxiosFile, ZrSwal } from 'utils'

const ProcesamientoPage = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [usuarios, setUsuarios] = React.useState([])
  const [usuarioSeleccionado, setUsuarioSeleccionado] = React.useState('')
  const [fechaProcesamiento, setFechaProcesamiento] = React.useState('')
  const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = React.useState('')

  React.useEffect(() => {
    UsuarioCrud.obtenerTodoAsSelect().then(({ data }) => {
      setUsuarios(data)
    })
  }, [])

  const clickDescargarReporteHadler = e => {
    e.preventDefault()
    TempInventarioCrud.getReporte(usuarioSeleccionado)
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'Reporte Inventario Fisico - Ingreso Manual.xlsx')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const procesarRegistros = () => {
    if (!fechaProcesamiento) {
      __zariContext.snack('error', 'Ingresar fecha')
      return
    }

    ZrSwal.showAlert({
      mensaje: `Los registros se procesarán bajo la sucursal ${__adminContext.nombreSede}, ¿Seguro que desea continuar?`,
      showCerrar: true,
      tipo: 'info',
      onSuccess: () => {
        TempInventarioCrud.procesarRegistros({ fechaProcesamiento })
          .then(() => {
            __zariContext.snack('success', 'Se han procesado los registros.')
            setMostrarModalConfirmacion(false)
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      }
    })
  }

  const clickVerificarFecha = e => {
    e.preventDefault()

    if (!fechaProcesamiento) {
      __zariContext.snack('error', 'Ingresar fecha')
      return
    }

    const mesActual = DateHandler.getMonth(new Date())
    const mesProcesamiento = DateHandler.getMonth(DateHandler.parse(fechaProcesamiento))

    if (mesActual === mesProcesamiento) {
      procesarRegistros()
    } else {
      setMostrarModalConfirmacion(true)
    }
  }

  return (
    <>
      <Row>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='Reporte de saldos de borrador' />
            <Portlet.Body>
              <Form.Group>
                <Form.Label text='USUARIO' htmlFor='select-usuario' md={2} />
                <Col md={4}>
                  <Form.Select
                    name='selectUsuario'
                    id='select-usuario'
                    value={usuarioSeleccionado}
                    onChange={e => setUsuarioSeleccionado(e.target.value)}
                  >
                    <option value=''>Todos</option>
                    {usuarios.map((x, k) => (
                      <option key={k} value={x._id}>
                        {x.username}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={4}>
                  <Button onClick={clickDescargarReporteHadler}>Decargar</Button>
                </Col>
              </Form.Group>
            </Portlet.Body>
          </Portlet>
        </Col>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='Procesamiento de Registros' />
            <Portlet.Body>
              <Form.Group>
                <Form.Label text='FECHA' htmlFor='input-fecha' md={2} />
                <Col md={4}>
                  <Form.InputDate
                    name='inputFecha'
                    id='input-fecha'
                    value={fechaProcesamiento}
                    onChange={e => setFechaProcesamiento(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Button onClick={clickVerificarFecha}>Confirmar</Button>
                </Col>
              </Form.Group>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
      {mostrarModalConfirmacion && (
        <ConfirmarProcesamientoModal
          handleClose={e => setMostrarModalConfirmacion(false)}
          show={mostrarModalConfirmacion}
          procesarRegistros={procesarRegistros}
        />
      )}
    </>
  )
}

export default ProcesamientoPage
